/**
 * Remove spaces and converts all the alphabetic characters in the string to lowercase.
 * @param x
 * @returns string
 * @example
 *  PORTFOLIO SALE -> portfoliosale
 */
export const lowerNoSpaces = (x: string) => x.toLowerCase().replace(/\s/g, '');
